/**
 * React でツールバーを描くための「空の箱」だけを提供する MapLibre コントロール。
 *
 * 右上/右下の縦積み・10px の余白・角丸・ボタン間の区切り線は MapLibre の CSS に
 * 任せたいが、中身は React で描きたい。そこで onAdd では渡された要素を返すだけにして、
 * React 側は createPortal でこの要素の「子」だけを管理する。これにより旧 LangControl /
 * MapStyleControl が持っていた絶対座標のマジックナンバー（top/right）が不要になる。
 *
 * 所有権の分担（これを守る限り React と MapLibre は衝突しない）:
 *   - 箱そのものの DOM への付け外し … MapLibre（addControl / map.remove）
 *   - 箱の中身                    … React（createPortal）
 *
 * onRemove で中身に触らないことが重要。React がまだ子要素を管理しているため、
 * ここで innerHTML を空にすると React のアンマウント時に removeChild が失敗しうる。
 * 逆に、JSX で描いた要素を onAdd でそのまま返す実装は避けること（MapLibre が
 * appendChild で親を移動させるため、React が記録した親と食い違う）。
 *
 * 参照: https://maplibre.org/maplibre-gl-js/docs/API/interfaces/IControl/
 */
import type { IControl, Map as MaplibreMap } from 'maplibre-gl';

export class PortalControl implements IControl {
  private readonly el: HTMLElement;

  /** @param el コントロール枠にする要素（`maplibregl-ctrl` クラスを含めておく）。 */
  constructor(el: HTMLElement) {
    this.el = el;
  }

  onAdd(_map: MaplibreMap): HTMLElement {
    return this.el;
  }

  onRemove(_map: MaplibreMap): void {
    // 箱を DOM から外すだけ。中身（React の子）は React に任せる。
    this.el.remove();
  }
}
